import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
const ProductSchemaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    description: "",
    image: "",
    offerType: "Offer",
    offerUrl: "",
    priceCurrency: "USD",
    price: "",
    aggregateRatingValue: "",
    numberOfRatings: "",
    highestAllowed: "",
    lowestAllowed: "",
    reviews: [],
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const addReview = () => {
    setFormData({
      ...formData,
      reviews: [...formData.reviews, { author: "", reviewBody: "", ratingValue: "" }],
    });
  };

  const handleReviewChange = (index, field, value) => {
    const updatedReviews = formData.reviews.map((review, i) =>
      i === index ? { ...review, [field]: value } : review
    );
    setFormData({ ...formData, reviews: updatedReviews });
  };

  const removeReview = (index) => {
    setFormData({
      ...formData,
      reviews: formData.reviews.filter((_, i) => i !== index),
    });
  };

 
  const [generatedSchema, setGeneratedSchema] = useState({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "",
  "image": "",
  "brand": "",
  "description": "",
  "offers": {
    "@type": "Offer",
    "url": "",
    "priceCurrency": "USD",
    "price": ""
  },
  "review": []


  });
  const generateSchema = () => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": formData.name,
      "image": formData.image,
      "brand": formData.brand,
      "description": formData.description,
      "offers": {
        "@type": formData.offerType,
        "url": formData.offerUrl,
        "priceCurrency": formData.priceCurrency,
        "price": formData.price,
      },
      "aggregateRating": formData.aggregateRatingValue
        ? {
            "@type": "AggregateRating",
            "ratingValue": formData.aggregateRatingValue,
            "reviewCount": formData.numberOfRatings,
            "bestRating": formData.highestAllowed,
            "worstRating": formData.lowestAllowed,
          }
        : undefined,
      "review": formData.reviews.map((review) => ({
        "@type": "Review",
        "author": review.author,
        "reviewBody": review.reviewBody,
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": review.ratingValue,
        },
      })),
    };
    setGeneratedSchema(JSON.stringify(schema, null, 2));
  };

  const copyToClipboard = () => {
    if (generatedSchema) {
      navigator.clipboard.writeText(JSON.stringify(generatedSchema, null, 2)).then(() => {
        toast.info("JSON-LD copied to clipboard!");
      });
    } else {
      toast.error("Generate the schema first!");
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    generateSchema();
  };

const deleteSchema = () => {
  setGeneratedSchema({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: "Dummy Article Headline",
      image: "https://example.com/dummy-image.jpg",
      author: {
        "@type": "Person",
        name: "John Doe",
        url: "https://example.com/author-profile",
      },
      publisher: {
        "@type": "Organization",
        name: "Dummy Publisher",
        logo: {
          "@type": "ImageObject",
          url: "https://example.com/dummy-logo.jpg",
        },
      },
      datePublished: "2025-01-01",
      dateModified: "2025-01-05",
      description: "This is a dummy description for an article schema.",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://example.com/dummy-article",
      },
    });
    toast.warning("Schema reset to dummy data!");
  };
  return (
    <div className="container mt-4">
      <ToastContainer/>
   
    <div className="row">
      <div className="col-md-6">
      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Product Details */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter product name"
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Image URL</label>
            <input
              type="text"
              className="form-control"
              name="image"
              value={formData.image}
              onChange={handleInputChange}
              placeholder="Enter image URL"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Brand</label>
            <input
              type="text"
              className="form-control"
              name="brand"
              value={formData.brand}
              onChange={handleInputChange}
              placeholder="Enter brand name"
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Product Description</label>
            <textarea
              className="form-control"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter product description"
              rows="3"
            ></textarea>
          </div>
        </div>

        {/* Offer Details */}
        <h5>Offer</h5>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Offer @type</label>
            <select
              name="offerType"
              className="form-select"
              value={formData.offerType}
              onChange={handleInputChange}
            >
              <option value="Offer">Offer</option>
              <option value="AggregateOffer">AggregateOffer</option>
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">URL</label>
            <input
              type="text"
              className="form-control"
              name="offerUrl"
              value={formData.offerUrl}
              onChange={handleInputChange}
              placeholder="Enter offer URL"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Price Currency</label>
            <select
              name="priceCurrency"
              className="form-select"
              value={formData.priceCurrency}
              onChange={handleInputChange}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">Price</label>
            <input
              type="text"
              className="form-control"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              placeholder="Enter price"
            />
          </div>
        </div>


        {/* Aggregate Rating */}
        <h5>Aggregate Rating</h5>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Aggregate Rating Value</label>
            <input
              type="text"
              className="form-control"
              name="aggregateRatingValue"
              value={formData.aggregateRatingValue}
              onChange={handleInputChange}
              placeholder="Enter rating value"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Number of Ratings</label>
            <input
              type="text"
              className="form-control"
              name="numberOfRatings"
              value={formData.numberOfRatings}
              onChange={handleInputChange}
              placeholder="Enter number of ratings"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Highest Value Allowed</label>
            <input
              type="text"
              className="form-control"
              name="highestAllowed"
              value={formData.highestAllowed}
              onChange={handleInputChange}
              placeholder="Enter highest allowed rating"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Lowest Value Allowed</label>
            <input
              type="text"
              className="form-control"
              name="lowestAllowed"
              value={formData.lowestAllowed}
              onChange={handleInputChange}
              placeholder="Enter lowest allowed rating"
            />
          </div>
        </div>

        {/* Reviews */}
        <h5>Reviews</h5>
        {formData.reviews.map((review, index) => (
          <div key={index} className="row align-items-end mb-2">
            <div className="col-md-12">
              <input
                type="text"
                className="form-control"
                value={review.author}
                onChange={(e) =>
                  handleReviewChange(index, "author", e.target.value)
                }
                placeholder="Author"
              />
            </div>
            <div className="col-md-12">
              <textarea
                className="form-control"
                value={review.reviewBody}
                onChange={(e) =>
                  handleReviewChange(index, "reviewBody", e.target.value)
                }
                placeholder="Review Body"
              ></textarea>
            </div>
            <div className="col-md-12 mt-2">
              <input
                type="text"
                className="form-control"
                value={review.ratingValue}
                onChange={(e) =>
                  handleReviewChange(index, "ratingValue", e.target.value)
                }
                placeholder="Rating Value"
              />
            </div>
            <div className="col-md-12 text-end mt-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => removeReview(index)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
        <button type="button" className="btn btn-primary mb-3" onClick={addReview}>
          + Add Review
        </button>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success w-100">
          Generate Schema
        </button>
      </form>
      </div>
      <div className="col-md-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            {generatedSchema ? (
              <div className="position-relative">
                <JSONPretty
                  id="json-pretty"
                  data={generatedSchema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
                
              </div>
            ) : (
              <p className="text-center">No schema generated yet.</p>
            )}
          </div>
        </div>
    </div>

     
    </div>
  );
};

export default ProductSchemaForm;
